import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  formContent: {
    margin: 0
  }
}));

export default styles;
